module.exports = __webpack_public_path__ + "static/img/list_banner.3fa11db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list_banner.jpg
// module id = Ul82
// module chunks = 0